import React from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Typography, Button, Stack } from '@mui/material';
// import { useGoogleLogin } from '@react-oauth/google';
import Iconify from '../../../components/iconify';
import logo from '../../../assets/img/ms.png'
import { useMsal } from '@azure/msal-react';


export const loginRequest = {
    scopes: ["User.Read"],
    prompt: "select_account"
};

const Azure = ({ showError, handleSuccess, loading, setLoading, method }) => {
    const { instance } = useMsal();
    const configData = useSelector((state) => state.configSlice);

    const getUserCredential = async (accessToken) => {
        try {
            setLoading(true);
            const bodyData = {
                access_token: accessToken,
            };
            const { data } = await axios.post(`${configData.config.UNO_URL}/api/auth/login/azure/${configData.config.applicationId}`, bodyData)
            const userData = {
                token: data.data.token,
                user: data.data.user,
            };
            handleSuccess(userData);

        } catch (error) {
            console.log(error);
            showError(error.response.data.message);
        } finally {
            setLoading(false)
        }
    };

    const acquireToken = async (account) => {
        try {
            instance.acquireTokenSilent({
                ...loginRequest,
                account: account,
            })
                .then(async (response) => {
                    getUserCredential(response.accessToken)
                });
        } catch (error) {
            console.log(error);
            showError(error.message);
        }
    }

    // const SignWithGoogle = useGoogleLogin({
    //     onSuccess: (tokenResponse) => {
    //       getUserCredential(tokenResponse?.access_token);
    //     },
    //     onError: (err) => {
    //       console.log(err);
    //       showError(err.message)
    //     },
    //   });
    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).then(result => {
                acquireToken(result.account);
            }).catch((e) => {
                console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).then(result => {
                acquireToken(result.account);
            }).catch((e) => {
                console.log(e);
                showError(e.message);
            });
        }
    }
    return (
        <Stack direction="row" spacing={2}>

            {loading ?
                <Button className='googlebtn' fullWidth size="large" color="inherit" variant="outlined">
                    <div className="wrapper">
                        <div className="blue ball" />
                        <div className="red ball" />
                        <div className="yellow ball" />
                        <div className="green ball" />
                    </div>
                </Button>
                :
                <Button className='googlebtn' fullWidth size="large" color="inherit" variant="outlined" onClick={() => handleLogin("popup")}>
                    {/* <Iconify icon="eva:google-fill" color="#DF3E30" width={22} height={22} /> */}
                    <img src={logo} style={{ width: '22px' }} />
                    <Typography variant="body2" sx={{ ml: 1 }}>
                        {method.text}
                    </Typography>
                </Button>
            }

        </Stack>
    )
}

export default Azure;
